export const themes = {
  tags: {
    750: ["750Amsterdam", "750amsterdam"],
  },
};
